import styled from "styled-components";

export const TableWrapper = styled.div`
  min-height: 100px;
  margin: 5px;
  height: 100%;
  position: relative;
  padding: 5px;
  background-color: #fff;

  .BaseTable__row.selected {
    background-color: #bddffb5c;
  }
`;
